import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import {
  FontTextSmBold,
  FontTextSmNormal,
  PrimitivesBluegray50,
  PrimitivesBluegray200,
  PrimitivesBluegray900,
  PrimitivesGreen600,
  PrimitivesRed700,
} from '@ambulnz/design-tokens';

const SuccessIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path
      d="M8.9375 13L13.8958 8.0625L12.8333 7L8.9375 10.875L7.16667 9.125L6.10417 10.1875L8.9375 13ZM10 18C8.90278 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6563C3.61458 14.9271 3.04167 14.0764 2.625 13.1042C2.20833 12.1319 2 11.0972 2 10C2 8.88889 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92361 3.04167 6.89583 2.625C7.86806 2.20833 8.90278 2 10 2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6563 4.34375C16.3854 5.07292 16.9583 5.92014 17.375 6.88542C17.7917 7.85069 18 8.88889 18 10C18 11.0972 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6563 15.6563C14.9271 16.3854 14.0799 16.9583 13.1146 17.375C12.1493 17.7917 11.1111 18 10 18ZM10 16.5C11.8056 16.5 13.3403 15.8681 14.6042 14.6042C15.8681 13.3403 16.5 11.8056 16.5 10C16.5 8.19444 15.8681 6.65972 14.6042 5.39583C13.3403 4.13194 11.8056 3.5 10 3.5C8.19444 3.5 6.65972 4.13194 5.39583 5.39583C4.13194 6.65972 3.5 8.19444 3.5 10C3.5 11.8056 4.13194 13.3403 5.39583 14.6042C6.65972 15.8681 8.19444 16.5 10 16.5Z"
      fill={PrimitivesGreen600}
    />
  </svg>
);

const FailIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path
      d="M10 11.0625L12.4167 13.4792C12.5694 13.6319 12.7465 13.7049 12.9479 13.6979C13.1493 13.691 13.3264 13.6111 13.4792 13.4583C13.6319 13.3056 13.7083 13.1285 13.7083 12.9271C13.7083 12.7257 13.6319 12.5489 13.4792 12.3967L11.0625 9.98958L13.4792 7.5825C13.6319 7.43028 13.7083 7.25347 13.7083 7.05208C13.7083 6.85069 13.6319 6.67361 13.4792 6.52083C13.3264 6.36806 13.1493 6.29167 12.9479 6.29167C12.7465 6.29167 12.5694 6.36806 12.4167 6.52083L10 8.9375L7.58333 6.52083C7.43056 6.36806 7.25694 6.29167 7.0625 6.29167C6.86806 6.29167 6.69444 6.36806 6.54167 6.52083C6.38889 6.67361 6.3125 6.85069 6.3125 7.05208C6.3125 7.25347 6.38826 7.43056 6.53979 7.58333L8.9375 10L6.52083 12.4167C6.36806 12.5694 6.29514 12.7431 6.30208 12.9375C6.30903 13.1319 6.38889 13.3056 6.54167 13.4583C6.69444 13.6111 6.87153 13.6875 7.07292 13.6875C7.27431 13.6875 7.45076 13.6117 7.60229 13.4602L10 11.0625ZM10.0058 18C8.90472 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6563C3.61458 14.9271 3.04167 14.0767 2.625 13.105C2.20833 12.1333 2 11.0951 2 9.99042C2 8.88569 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92333 3.04167 6.895 2.625C7.86667 2.20833 8.90486 2 10.0096 2C11.1143 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6563 4.34375C16.3854 5.07292 16.9583 5.92167 17.375 6.89C17.7917 7.85847 18 8.89319 18 9.99417C18 11.0953 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6563 15.6563C14.9271 16.3854 14.0783 16.9583 13.11 17.375C12.1415 17.7917 11.1068 18 10.0058 18ZM10 16.5C11.8056 16.5 13.3403 15.8681 14.6042 14.6042C15.8681 13.3403 16.5 11.8056 16.5 10C16.5 8.19444 15.8681 6.65972 14.6042 5.39583C13.3403 4.13194 11.8056 3.5 10 3.5C8.19444 3.5 6.65972 4.13194 5.39583 5.39583C4.13194 6.65972 3.5 8.19444 3.5 10C3.5 11.8056 4.13194 13.3403 5.39583 14.6042C6.65972 15.8681 8.19444 16.5 10 16.5Z"
      fill={PrimitivesRed700}
    />
  </svg>
);

const Grid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
  alignSelf: 'stretch',
});

const STATUS_PRESENTATION = {
  success: { label: 'Success', borderColor: PrimitivesGreen600, Icon: SuccessIcon },
  failure: { label: 'Failure', borderColor: PrimitivesRed700, Icon: FailIcon },
  not_applicable: { label: 'Not applicable', borderColor: PrimitivesBluegray200, Icon: null },
  unknown: { label: 'Unknown', borderColor: PrimitivesBluegray200, Icon: null },
};

const DEFAULT_STATUS_PRESENTATION = STATUS_PRESENTATION.unknown;

const getStatusPresentation = (status) => STATUS_PRESENTATION[status] || DEFAULT_STATUS_PRESENTATION;

const Card = styled(Box)(({ status }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px 24px',
  minWidth: '300px',
  borderRadius: '8px',
  border: `1px solid ${getStatusPresentation(status).borderColor}`,
  backgroundColor: PrimitivesBluegray50,
}));

const PayerName = styled(Typography)({
  ...FontTextSmBold,
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '20px',
  color: PrimitivesBluegray900,
  width: '100%',
});

const StatusRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

const StatusLabel = styled(Typography)({
  ...FontTextSmNormal,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  color: PrimitivesBluegray900,
});

function getPayerName(cov, infoboxCoverages) {
  if (cov.payer?.name) return cov.payer.name;
  if (cov.payerName) return cov.payerName;
  const infoCov = infoboxCoverages?.[cov.coordinationTypeId];
  return infoCov?.payer?.name || infoCov?.payer?.entity?.name || '';
}

function PayerCardsGrid({ coverages = [], infoboxCoverages = {} }) {
  if (coverages.length === 0) return null;

  return (
    <Grid>
      {coverages.map((cov, index) => {
        const { label, Icon } = getStatusPresentation(cov.status);

        return (
          <Card key={cov.coordinationTypeId || index} status={cov.status}>
            <PayerName>{getPayerName(cov, infoboxCoverages)}</PayerName>
            <StatusRow>
              <StatusLabel>Eligibility Status: {label}</StatusLabel>
              {Icon && (
                <Box sx={{ display: 'flex', flexShrink: 0 }}>
                  <Icon />
                </Box>
              )}
            </StatusRow>
          </Card>
        );
      })}
    </Grid>
  );
}

PayerCardsGrid.propTypes = {
  coverages: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      payer: PropTypes.shape({
        name: PropTypes.string,
      }),
      payerName: PropTypes.string,
      coordinationTypeId: PropTypes.number,
    }),
  ),
  infoboxCoverages: PropTypes.shape({}),
};

export default PayerCardsGrid;
